import { CheckCircle2, Quote } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const PORTRAIT_IMG = "/images/witali.jpg";

const values = [
  "Bewertungsfreier, vertraulicher Raum",
  "Klare, lösungsorientierte Begleitung",
  "Flexibel – online und nach Vereinbarung persönlich",
  "In deinem Tempo, ohne Druck",
];

export default function About() {
  return (
    <section id="ueber" data-testid="about-section" className="relative py-28 sm:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
          {/* Portrait */}
          <Reveal className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative max-w-md">
              <div className="absolute -inset-8 rounded-full bg-[radial-gradient(circle_at_50%_40%,rgba(216,154,122,0.3),transparent_60%)] blur-2xl pointer-events-none" />
              <div className="relative rounded-[2rem] overflow-hidden shadow-[0_40px_80px_-30px_rgba(60,34,19,0.45)]">
                <img
                  src={PORTRAIT_IMG}
                  alt="Portrait von Witali Albrecht, psychologischer Berater"
                  loading="lazy"
                  className="w-full h-auto object-cover"
                  data-testid="about-portrait"
                />
                <div className="absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-[#3C2213]/40 to-transparent" />
                <div className="absolute left-6 bottom-6 text-[10px] tracking-[0.3em] uppercase text-[#F2DFC6]/85">
                  — Witali Albrecht
                </div>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-7 order-1 lg:order-2 max-w-3xl">
          <Reveal>
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#93401D] mb-5">
              Über mich
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[3.5rem] tracking-tight leading-[1.02] text-[#29170C]">
              Schön, dass du da bist.
              <br />
              <span className="italic text-[#93401D]">Ich bin Witali.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-[#63432B]">
              <p className="rounded-2xl bg-[#EAD0AE]/50 border-l-4 border-[#93401D] px-6 py-5 text-[#29170C]">
                <span className="block text-[11px] tracking-[0.25em] uppercase text-[#93401D] mb-2 not-italic font-medium">
                  Meine Ausbildung
                </span>
                Durch meine Ausbildung zum Psychologischen Berater habe ich
                gelernt, Menschen bei persönlichen Herausforderungen strukturiert
                und einfühlsam zu begleiten.
              </p>
              <p>
                Dieser Weg ist für mich mehr als ein Beruf: Ich weiß aus eigener
                Erfahrung, wie es sich anfühlt, wenn das Leben schwer wird – und
                wie viel es verändert, wenn einem jemand wirklich zuhört. Genau
                deshalb tue ich, was ich tue.
              </p>
              <p>
                Ich arbeite persönlich, klar und respektvoll. Bei mir gibt es
                keine Bewertung und kein „So gehört sich das“ – sondern einen
                geschützten Raum, in dem du so sein darfst, wie du gerade bist.
              </p>
              <p>
                Wichtig zu wissen: Ich bin psychologischer Berater, kein
                Psychotherapeut und kein Arzt. Meine Beratung ersetzt keine
                heilkundliche Behandlung – sie kann aber ein wertvoller erster
                Schritt sein.
              </p>
            </div>
          </Reveal>

          <ul className="mt-10 grid sm:grid-cols-2 gap-3">
            {values.map((v, i) => (
              <Reveal
                key={v}
                delay={0.25 + i * 0.08}
                as="li"
                className="flex items-start gap-3 text-[15px] text-[#29170C]"
              >
                <CheckCircle2 size={18} strokeWidth={1.5} className="text-[#93401D] shrink-0 mt-0.5" />
                <span>{v}</span>
              </Reveal>
            ))}
          </ul>

          <Reveal delay={0.3}>
            <div className="mt-12 flex items-start gap-5 rounded-[1.75rem] bg-[#EAD0AE]/60 border border-[#E0BD93] p-7 sm:p-8">
              <Quote size={32} strokeWidth={1.2} className="text-[#C98250] shrink-0 mt-1" />
              <div>
                <p className="font-serif text-xl sm:text-2xl italic text-[#29170C] leading-snug">
                  „Veränderung beginnt dort, wo du dich verstanden fühlst.“
                </p>
                <div className="mt-3 text-[11px] tracking-[0.25em] uppercase text-[#93401D]">
                  Mein Grundsatz
                </div>
              </div>
            </div>
          </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
